export const APP_LABEL = {
  "Label.Font.Size": {
    ref: "Font.Size.14"
  },
  "Label.Color": {
    ref: "Color.Black"
  },
  "Label.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Label.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Label.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Label.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Label.Hover.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Label.Border.Color": {
    ref: "Color.Transparent"
  },
  "Label.Hover.Border.Color": {
    ref: "Color.Transparent"
  },
  "Label.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Label.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Label.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Label.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Label.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Label.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Label.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Label.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Label.Border.Style": {
    defaultValue: "solid"
  },
  "Label.Padding.Top": {
    defaultValue: "0px"
  },
  "Label.Padding.Right": {
    defaultValue: "0px"
  },
  "Label.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Label.Padding.Left": {
    defaultValue: "0px"
  },
  "Label.Hover.Color": {
    ref: "Color.Black"
  },
  "Label.Hover.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Label.Font.Style": {
    defaultValue: "normal"
  },
  "Label.Text.Decoration": {
    defaultValue: "none"
  },
  "Label.Width": {
    defaultValue: "auto"
  },
  "Label.Height": {
    defaultValue: "auto"
  },
  "Label.Min.Height": {
    defaultValue: "0px"
  },
  "Label.Min.Width": {
    defaultValue: "0px"
  },
  "Label.Max.Height": {
    defaultValue: "unset"
  },
  "Label.Max.Width": {
    defaultValue: "unset"
  },
  "Label.Margin.Top": {
    defaultValue: "0px"
  },
  "Label.Margin.Right": {
    defaultValue: "0px"
  },
  "Label.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Label.Margin.Left": {
    defaultValue: "0px"
  },
  "Label.Overflow": {
    defaultValue: "auto"
  },
  "Label.Cursor": {
    defaultValue: "pointer"
  },
  "Label.Box.Sizing": {
    defaultValue: "border-box"
  }
};
